import { blue, green, grey, yellow } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import LegendIcon from '@material-ui/icons/FiberManualRecord';
import React, { FC } from 'react';
import AppAlert from '../../ui/alert/AppAlert';
import { AppText } from '../../ui/text';

const useStyles = makeStyles(
  (theme) => ({
    legendElement: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      marginRight: theme.spacing(2),
    },
  }),
  { name: 'RequestsListLegend' },
);

const RequestsListLegend: FC = () => {
  const classes = useStyles();
  return (
    <AppAlert title="Legenda" severity="info" style={{ backgroundColor: 'white' }}>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: yellow[600] }} />
        Richiesta in attesa di essere processata
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: blue[300] }} />
        Richiesta processata ma non notificata
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: green[300] }} />
        Richiesta notificata al PVP
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: grey[400] }} />
        Report dell'esperimento di vendita inviato
      </AppText>
    </AppAlert>
  );
};

export default RequestsListLegend;
